import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import { OrderSummaryRowSkeleton } from "./OrderSummaryRowSkeleton";
import { ShipMethodSkeleton } from "./shipMethodSkeleton";

export const BrandSkeleton = ({ count = 4 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <BrandSkeletonContainer key={i} />
      ))}
    </>
  );
};

const BrandSkeletonContainer = () => {
  return (
    <div className="col-4 col-sm-3 col-md-3 col-lg-3 mt-3 mt-lg-4">
      <div className="branding-list">
        <div className="brand-list-effect">
          <Skeleton width={180} height={100} />
          <div style={{ marginTop: 10 }}>
            <Skeleton width="60%" height={14} />
          </div>
        </div>
      </div>
    </div>
  );
};
